import React from 'react';
import { QuoteIcon } from 'lucide-react';
export function EnrichmentUseCases() {
  return <section className="py-24 bg-white border-t border-slate-100" data-id="element-2925">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2926">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-2927">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-2928">
            Local business data enrichment for{' '}
            <span className="text-blue-600" data-id="element-2929">every team</span>
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-2930">
            From sales to marketing, see how teams use local business contact
            enrichment to grow.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-2931">
          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-2932">
            <div data-id="element-2933">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-2934">
                CRM enrichment
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-2935">
                Enrich your Salesforce or HubSpot with verified local business
                contacts, owner emails, and business profiles.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-2936">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-2937" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-2938">
                We enriched 50,000 local business records in our CRM over a
                single weekend.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-2939">
                — Rachel K., RevOps lead
              </p>
            </div>
          </div>

          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-2940">
            <div data-id="element-2941">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-2942">
                Sales prospecting
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-2943">
                Turn basic local business lists into outreach-ready prospect
                data with verified emails and direct phones.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-2944">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-2945" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-2946">
                Local business contact enrichment doubled our SDR team's connect
                rate.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-2947">
                — James T., Sales director
              </p>
            </div>
          </div>

          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-2948">
            <div data-id="element-2949">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-2950">
                Market research
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-2951">
                Enrich local business data with tech stacks, revenue, and
                employee counts to identify high-value segments.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-2952">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-2953" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-2954">
                Business profile enrichment helped us find 3 underserved markets
                in our first month.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-2955">
                — Lisa P., Strategy manager
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}